import React, { useEffect } from 'react';

import {
  RoomAudioRenderer,
  useLocalParticipant,
  useRoomContext,
  useTrackVolume,
  useVoiceAssistant
} from '@livekit/components-react';
import { normalize } from 'shared/utils/math';

interface LiveKitVoiceAgentSessionProps {
  setIsLoading: (isLoading: boolean) => void;
  setCurrentCombinedVolume?: (volume: number) => void;
  onSessionEnd: () => void;
}

const MAX_COMBINED_VOLUME = 2;

export function LiveKitVoiceAgentSession({
  setIsLoading,
  onSessionEnd,
  setCurrentCombinedVolume
}: LiveKitVoiceAgentSessionProps) {
  const { state: agentState, audioTrack } = useVoiceAssistant();
  const { microphoneTrack } = useLocalParticipant();
  const agentAudioLevel = useTrackVolume(audioTrack);
  const localAudioLevel = useTrackVolume(microphoneTrack?.audioTrack);
  const room = useRoomContext();

  useEffect(() => {
    if (agentState === 'speaking') setIsLoading(false);
  }, [agentState]);

  useEffect(() => {
    const normalizedVolume = normalize(agentAudioLevel + localAudioLevel, 0, MAX_COMBINED_VOLUME);
    if (setCurrentCombinedVolume) setCurrentCombinedVolume(normalizedVolume);
  }, [agentAudioLevel, localAudioLevel, setCurrentCombinedVolume]);

  useEffect(() => {
    room.on('disconnected', onSessionEnd);

    return () => {
      room.off('disconnected', onSessionEnd);
    };
  }, [room]);

  return <RoomAudioRenderer />;
}
